import { Link, Outlet } from "react-router-dom";

import Navigation from "../Components/Navigation";
import CalmCoastLogo from "../Assets/CalmCoastNoBgSq.png";
import HypnotherapyConsentForm from "../Assets/Hypnotherapy Consent Form.docx";

export default function MainLayout() {

  return (
    <div className="h-full min-h-full flex flex-col bg-coastal-100">
      {/* Top Bar */}
      <header className="px-5 flex justify-between bg-coastal-700 shadow-sm">

        {/* Banner */}
        <div className="m-3 flex items-center jusify-center">
          <div className="bg-white/95 my-auto rounded-full p-1">
            <Link to="/">
              <img src={CalmCoastLogo} alt="Calm Coast Hypnotherapy" className="h-[8.5vh] p-1 w-auto" />
            </Link>
          </div>
          <div className="hidden text-white p-4 my-auto md:inline">
            <h1 className="text-2xl lg:text-4xl whitespace-nowrap font-bold font-roboto">Calm Coast Hypnotherapy</h1>
            <p className="text-sm lg:text-base text-coastal-100">Calm, focused and positive forward movement</p>
          </div>
        </div>

        {/* Nav */}
        <Navigation />
      </header>

      {/* Main area */}
      <main className="p-4 grow overflow-auto">
        <Outlet />
      </main>

      <footer className="w-full border-t border-coastal-600 bg-coastal-700 px-3 py-2 sm:p-3">
        <div className="mx-auto flex max-w-6xl flex-col gap-1 text-xs text-coastal-100 sm:flex-row sm:flex-wrap sm:items-center sm:justify-between sm:gap-2 sm:text-sm">
          <a href="mailto:calmcoasthypnotherapy@hotmail.com" className="truncate underline hover:text-white">
            calmcoasthypnotherapy@hotmail.com
          </a>
          <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-[11px] sm:text-sm">
            <span className="hidden sm:inline">Insurance: Holistic Insurance</span>
            <span className="hidden sm:inline">NBH accredited</span>
            <Link to="/privacy-policy" className="underline hover:text-white">Privacy policy</Link>
            <Link to="/cancellation-policy" className="underline hover:text-white">Cancellation policy</Link>
            <a href={HypnotherapyConsentForm} download className="underline hover:text-white">Consent form</a>
          </div>
        </div>
      </footer>
    </div>
  )
}